<div class="policy-hints">
  <p class="policy-hints__title">Password must have:</p>
  <div class="policy-hints__item" *ngFor="let hint of hints"
       [class.policy-hints__item--personal]="hint.key === 'noPersonalInfo'"
       [class.policy-hints__item--fail]="isHintFailed(hint)"
       [class.policy-hints__item--pass]="!isHintFailed(hint)">
    <i class="material-icons"
       [class.policy-hints__icon--pass]="!isHintFailed(hint)">{{ isHintFailed(hint) ? 'cancel' : 'check_circle' }}</i>
    <ng-container *ngIf="hint.key === 'noPersonalInfo'; else plainHint">
      <span>
        <span class="policy-hints__msg">Don't use any personal information</span> .
        (<ng-container *ngFor="let part of personalParts; let last = last">
          <span [class]="personalPartClass(part.key)">{{ part.label }}</span><span *ngIf="!last">, </span>
        </ng-container>)
      </span>
    </ng-container>
    <ng-template #plainHint>
      <span>{{ hint.label }}</span>
    </ng-template>
  </div>
</div>
